
/*
 * renders when the collection is empty. Can be used
 * on with virtual elements.
 * @param anyArray any array observable or not
 * @example <!-- ko empty: collection -->content<!-- /ko -->
 */
ko.bindingHandlers.empty = {
  init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    return ko.bindingHandlers['if']['init'](element, (function() {
      return ko.computed(function() {
        return !helpers.hasItems(valueAccessor());
      });
    }), allBindings, viewModel, bindingContext);
  }
};

ko.virtualElements.allowedBindings.empty = true;
